import { render } from "./EducationSection.vue?vue&type=template&id=18fc07cd"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__